<template>
    <div class="relative">
        <div v-if="loadingPivot">
            <div class="mt-2 absolute flex justify-center items-center z-[60] w-full">
                <div class="w-24 h-24 m-auto my-8">
                    <LoadingIcon icon="oval" class="w-8 h-8 loading-icon" />
                </div>
            </div>
            <div class="absolute bg-white opacity-70 w-full h-full z-50 flex justify-center items-center" v-if="isRendered">
            </div>
        </div>
        <div class="overflow-x-scroll mt-2">
            <div id="output" class=""></div>
        </div>
    </div>
</template>

<script setup>
import {onMounted, watch, ref} from "vue"
import jQuery from 'jquery'
import axios from "axios"
import Swal from "sweetalert2";
import { useStore } from "vuex";

const props = defineProps({
    filter: Object
})
const store = useStore()
watch(()=>props.filter, ()=>{
    getPivotData()
})
const loadingPivot = ref(false)
const isRendered = ref(false)
const pivotReady = ref(false)

const initPivot = async () => {
    window.$ = window.jQuery = jQuery
    await import('pivottable')
    await import('jquery-ui')
    await import('pivottable/dist/export_renderers')
    pivotReady.value = true
}
const getPivotData = async () =>{
    loadingPivot.value = !loadingPivot.value
    const token = store.getters["userAuth/getToken"];
    const url = `${process.env.VUE_APP_BASE_API}member/getMemberPivotData`;
    const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": `application/json; charset=utf-8`,
    };
    const res = await axios.post(url, props.filter, { headers })
        .catch(() =>{
            setTimeout(()=>{loadingPivot.value = !loadingPivot.value}, 500)
            Swal.fire({
                icon: "warning",
                text: "ระบบผิดพลาด",
            })
        }
    );
    if(res.status == 200){
        isRendered.value = true
        setTimeout(()=>{loadingPivot.value = !loadingPivot.value}, 500)
        // let filtered = res.data.filter((item)=>)
        /*var result = res.data.map(data => (
            {
                "จำนวนครัวเรือน": data.cnt_household,
                "จำนวนสมาชิก": data.cnt_member,
                "จำนวนสมาชิกในภาวะพึ่งพิง": data.cnt_dependent_member,
                "สถานะ": data.status,
                "จังหวัด" : data.province_name,
                "อำเภอ": data.amphur_name,
                "ตำบล": data.tumbol_name,
                "สสว": data.osm,
                "ระดับความเปราะบาง": data.fragile_level,
                "มิติสุขภาพ": data.dim_health,
                "มิติความเป็นอยู่": data.dim_family,
                "มิติการศึกษา": data.dim_education,
                "มิติรายได้": data.dim_occupation,
                "มิติการเข้าถึงบริการรัฐ": data.dim_accessibility,
                "ด้านที่อยู่อาศัย": data.prob_housing,
                "ด้านสุขภาพอนามัย": data.prob_health,
                "ด้านการศึกษา": data.prob_education,
                "ด้านการมีรายได้": data.prob_occupation,
                "ด้านครอบครัว": data.prob_family,
                "ด้านความรุนแรงในครอบครัว": data.prob_violence,
                "ด้านการค้ามนุษย์": data.prob_human_trafficking,
                "ด้านการเข้าไม่ถึงสิทธิ": data.prob_accessibility,
                "ด้านอื่น ๆ": data.prob_others,
                "ลักษณะครัวเรือน": data.hh_type,
                "ที่ตั้งที่พัก": data.house_type,
                "มีความมั่นคงแข็งแรง": data.house_solid,
                "ที่อยู่อาศัยเหมาะสม": data.env_suitable,
                "มีเด็กเล็ก": data.have_youngchild,
                "มีเด็ก": data.have_child,
                "มีเยาวชน": data.have_adolescence,
                "มีวัยผู้ใหญ่": data.have_adult,
                "มีผู้สูงอายุ": data.have_elderly,
                "มีคนพิการ": data.have_disabled,
                "มีผู้ทำการขอทาน": data.have_beggar,
                "มีคนไร้ที่พึ่ง": data.have_helpless,
                "มีผู้ตั้งครรภ์วัยรุ่น": data.have_adolescent_pregnancy,
                "มีความรุนแรงในครอบครัว": data.have_family_violence,
                "มีการค้ามนุษย์": data.have_human_trafficking,
                "มีพ่อ/แม่เลี้ยงเดี่ยว": data.have_single_parents,
            }
        ));*/
        var result = res.data.map(data => {
            let temp = {}
            if(typeof data.cnt_household != "undefined"){
                temp["จำนวนครัวเรือน"] = data.cnt_household
            }
            if(typeof data.cnt_member != "undefined"){
                temp["จำนวนสมาชิก"] = data.cnt_member
            }
            if(typeof data.cnt_dependent_member != "undefined"){
                temp["จำนวนสมาชิกในภาวะพึ่งพิง"] = data.cnt_dependent_member
            }
            if(data.status){
                temp["สถานะ"] = data.status
            }
            if(data.province_name){
                temp["จังหวัด"] = data.province_name
            }
            if(data.amphur_name){
                temp["อำเภอ"] = data.amphur_name
            }
            if(data.tumbol_name){
                temp["ตำบล"] = data.tumbol_name
            }
            if(data.village_name){
                temp["ชุมชน"] = data.village_name
            }
            if(data.osm){
                temp["สสว"] = data.osm
            }
            if(typeof data.fragile_level != "undefined"){
                temp["ระดับความเปราะบาง"] = data.fragile_level
            }
            if(data.dim_health){
                temp["มิติสุขภาพ"] = data.dim_health
            }
            if(data.dim_family){
                temp["มิติความเป็นอยู่"] = data.dim_family
            }
            if(data.dim_education){
                temp["มิติการศึกษา"] = data.dim_education
            }
            if(data.dim_occupation){
                temp["มิติรายได้"] = data.dim_occupation
            }
            if(data.dim_accessibility){
                temp["มิติการเข้าถึงบริการรัฐ"] = data.dim_accessibility
            }
            if(data.prob_housing){
                temp["ด้านที่อยู่อาศัย"] = data.prob_housing
            }
            if(data.prob_health){
                temp["ด้านสุขภาพอนามัย"] = data.prob_health
            }
            if(data.prob_education){
                temp["ด้านการศึกษา"] = data.prob_education
            }
            if(data.prob_occupation){
                temp["ด้านการมีรายได้"] = data.prob_occupation
            }
            if(data.prob_family){
                temp["ด้านครอบครัว"] = data.prob_family
            }
            if(data.prob_violence){
                temp["ด้านความรุนแรงในครอบครัว"] = data.prob_violence
            }
            if(data.prob_human_trafficking){
                temp["ด้านการค้ามนุษย์"] = data.prob_human_trafficking
            }
            if(data.prob_accessibility){
                temp["ด้านการเข้าไม่ถึงสิทธิ"] = data.prob_accessibility
            }
            if(data.prob_others){
                temp["ด้านอื่น ๆ"] = data.prob_others
            }
            if(data.hh_type){
                temp["ลักษณะครัวเรือน"] = data.hh_type
            }
            if(data.house_type){
                temp["ที่ตั้งที่พัก"] = data.house_type
            }
            if(data.house_solid){
                temp["มีความมั่นคงแข็งแรง"] = data.house_solid
            }
            if(data.env_suitable){
                temp["ที่อยู่อาศัยเหมาะสม"] = data.env_suitable
            }
            if(data.have_youngchild){
                temp["มีเด็กเล็ก"] = data.have_youngchild
            }
            if(data.have_child){
                temp["มีเด็ก"] = data.have_child
            }
            if(data.have_adolescence){
                temp["มีเยาวชน"] = data.have_adolescence
            }
            if(data.have_adult){
                temp["มีวัยผู้ใหญ่"] = data.have_adult
            }
            if(data.have_elderly){
                temp["มีผู้สูงอายุ"] = data.have_elderly
            }
            if(data.have_disabled){
                temp["มีคนพิการ"] = data.have_disabled
            }
            if(data.have_beggar){
                temp["มีผู้ทำการขอทาน"] = data.have_beggar
            }
            if(data.have_helpless){
                temp["มีคนไร้ที่พึ่ง"] = data.have_helpless
            }
            if(data.have_adolescent_pregnancy){
                temp["มีผู้ตั้งครรภ์วัยรุ่น"] = data.have_adolescent_pregnancy
            }
            if(data.have_family_violence){
                temp["มีความรุนแรงในครอบครัว"] = data.have_family_violence
            }
            if(data.have_human_trafficking){
                temp["มีการค้ามนุษย์"] = data.have_human_trafficking
            }
            if(data.have_single_parents){
                temp["มีพ่อ/แม่เลี้ยงเดี่ยว"] = data.have_single_parents
            }
            return temp

        })
        var sum = jQuery.pivotUtilities.aggregatorTemplates.sum;
        var numberFormat = jQuery.pivotUtilities.numberFormat;
        var intFormat = numberFormat({digitsAfterDecimal: 0});
        let renderers = jQuery.extend(jQuery.pivotUtilities.renderers,jQuery.pivotUtilities.export_renderers);
        jQuery("#output").pivotUI(
            result,
            {
                hiddenAttributes:['จำนวนครัวเรือน','จำนวนสมาชิก','จำนวนสมาชิกในภาวะพึ่งพิง'],
                aggregators: {
                    'จำนวนครัวเรือน': function() {return sum(intFormat)(['จำนวนครัวเรือน'])},
                    'จำนวนสมาชิก': function() {return sum(intFormat)(['จำนวนสมาชิก'])},
                    'จำนวนสมาชิกในภาวะพึ่งพิง': function() {return sum(intFormat)(['จำนวนสมาชิกในภาวะพึ่งพิง'])},
                },
                onRefresh: function(config) {
                    jQuery(".pvtCheckContainer").find(".count").hide();
                },
            },
            {
                rows: [],
                cols: [],
                vals: [],
                aggregatorName: "Count",
                renderers: renderers,
                rendererName: "Table",
            }
        );
    }
}
onMounted(async ()=>{
    await initPivot()
    await getPivotData()
})

</script>

<style lang="scss">
@import url("pivottable/dist/pivot.css");
table.pvtTable{
    width: 100%;
}
.pvtUi{
    width: 100%;
}
.pvtFilterBox button {
    background: #e6e6e6;
    border: 1px solid;
    margin-right: 5px;
    padding: 2px 5px;
}
.pvtUiCell{
    border: 2px solid;
    border-color: #b6c1dd;
    select {
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 5px;
    }
}
.pvtRenderer{
    width: 100%;
}
.pvtAttrDropdown {
    margin-right: 5px;
}
.pvtAxisContainer {
    li span.pvtAttr {
        background: #e1e7f0;
        border: 1px solid #071a503b;
        color: #071a50;
    }
    background: #e3e6ed6e;
}
.pvtVals{
    background: #e3e6ed6e;
}
table.pvtTable thead tr th, table.pvtTable tbody tr th {
    background-color: #6e85c540;
    border: 1px solid #071a5059;
}
.pvtTriangle{
    color: #071a50;
}

</style>